var exports = {
  "kL": "xdbfd91f1--d753fe--container",
  "wx": "xdbfd91f1--d753fe--header",
  "VA": "xdbfd91f1--d753fe--site_address_container",
  "ZW": "xdbfd91f1--d753fe--site_address",
};

module.exports = exports;
